import gql from 'graphql-tag'

export const UPDATE_TEAM_MEMBER = gql`
  mutation UpdateTeamMember($userUuid: ID!, $brandUuid: ID!, $position: PositionInput!) {
    updateTeamMember(userUuid: $userUuid, brandUuid: $brandUuid, position: $position) {
      securityLevel
      defaultRole
      title
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/UpdateTeamMember.tsx